"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sliderValueToGraphValue = exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _TaskSlider = _interopRequireDefault(require("../TaskSlider/TaskSlider"));
var _chart = require("chart.js");
var _reactChartjs = require("react-chartjs-2");
var _Hooks = require("../Hooks");
var _Row = _interopRequireDefault(require("react-bootstrap/Row"));
var _Col = _interopRequireDefault(require("react-bootstrap/Col"));
require("./styles.css");
var _excluded = ["state"];
_chart.Chart.register(_chart.LinearScale, _chart.PointElement, _chart.LineElement, _chart.Tooltip, _chart.Legend);
var sliderValueToGraphValue = function sliderValueToGraphValue(sliderValue, trackRange, roundValues) {
  for (var i = 0; i < trackRange.length; ++i) {
    if (sliderValue <= trackRange[i].maxAnchor && sliderValue >= trackRange[i].minAnchor) {
      var _trackRange$i$min$val, _trackRange$i$min, _trackRange$i$max$val, _trackRange$i$max;
      var min = (_trackRange$i$min$val = (_trackRange$i$min = trackRange[i].min) === null || _trackRange$i$min === void 0 ? void 0 : _trackRange$i$min.value) !== null && _trackRange$i$min$val !== void 0 ? _trackRange$i$min$val : trackRange[i].min;
      var max = (_trackRange$i$max$val = (_trackRange$i$max = trackRange[i].max) === null || _trackRange$i$max === void 0 ? void 0 : _trackRange$i$max.value) !== null && _trackRange$i$max$val !== void 0 ? _trackRange$i$max$val : trackRange[i].max;
      var segmentPercentage = (sliderValue - trackRange[i].minAnchor) / (trackRange[i].maxAnchor - trackRange[i].minAnchor);
      return parseFloat(Number(min + (max - min) * segmentPercentage).toFixed(roundValues !== null && roundValues !== void 0 ? roundValues : 2));
    }
  }
};
exports.sliderValueToGraphValue = sliderValueToGraphValue;
var TaskGraphSlider = function TaskGraphSlider(_ref) {
  var _props$completed;
  var state = _ref.state,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useCompletion = (0, _Hooks.useCompletion)(state, (_props$completed = props.completed) !== null && _props$completed !== void 0 ? _props$completed : false),
    _useCompletion2 = (0, _slicedToArray2.default)(_useCompletion, 2),
    completed = _useCompletion2[0],
    setCompleted = _useCompletion2[1];
  var viewedArray = [];
  for (var i = 0; i < props.displayText.length; i++) {
    var _loop = function _loop(sliderIndex) {
      var text = props.displayText[i];
      var found = viewedArray.find(function (value) {
        return value.range[0] === text.sliderRanges[sliderIndex][0] && value.range[1] === text.sliderRanges[sliderIndex][1] && value.sliderIndex === sliderIndex;
      });
      if (!found) {
        viewedArray.push({
          range: text.sliderRanges[sliderIndex],
          sliderIndex: sliderIndex
        });
      }
    };
    for (var sliderIndex = 0; sliderIndex < props.sliders.length; sliderIndex++) {
      _loop(sliderIndex);
    }
  }
  var _useStorageState = (0, _Hooks.useStorageState)(state, "textViewed", viewedArray),
    _useStorageState2 = (0, _slicedToArray2.default)(_useStorageState, 2),
    textViewed = _useStorageState2[0],
    setTextViewed = _useStorageState2[1];
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var graphWidthRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var unvisitedRanges = 0;
    for (var _i = 0; _i < textViewed.length; _i++) {
      unvisitedRanges += textViewed[_i].size;
    }
    if (!completed && unvisitedRanges === 0) {
      setCompleted(true);
    }
  }, [textViewed]);
  (0, _react.useLayoutEffect)(function () {
    setWidth(graphWidthRef.current.clientWidth);
  }, []);
  (0, _react.useEffect)(function () {
    for (var _i2 = 0; _i2 < props.sliders.length; ++_i2) {
      props.sliders[_i2].setValue(sliderValueToGraphValue(props.sliders[_i2].initialPosition, props.trackRanges[_i2], props.roundValues));
    }
  }, []);
  var generateMarks = function generateMarks(trackRange) {
    var marks = {};
    for (var _i3 = 0; _i3 < trackRange.length; ++_i3) {
      var _trackRange$_i3$min$l, _trackRange$_i3$min;
      marks[trackRange[_i3].minAnchor] = (_trackRange$_i3$min$l = (_trackRange$_i3$min = trackRange[_i3].min) === null || _trackRange$_i3$min === void 0 ? void 0 : _trackRange$_i3$min.label) !== null && _trackRange$_i3$min$l !== void 0 ? _trackRange$_i3$min$l : trackRange[_i3].min;
      if (_i3 === trackRange.length - 1) {
        var _trackRange$_i3$max$l, _trackRange$_i3$max;
        marks[trackRange[_i3].maxAnchor] = (_trackRange$_i3$max$l = (_trackRange$_i3$max = trackRange[_i3].max) === null || _trackRange$_i3$max === void 0 ? void 0 : _trackRange$_i3$max.label) !== null && _trackRange$_i3$max$l !== void 0 ? _trackRange$_i3$max$l : trackRange[_i3].max;
      }
    }
    return marks;
  };
  var getDisplayAndAltText = function getDisplayAndAltText() {
    var displayText = [];
    var altText = [];
    var viewedCopy = textViewed.slice();
    var _loop2 = function _loop2(_i4) {
      var pass = true;
      var _loop3 = function _loop3(s) {
        if (props.sliders[s].value >= props.displayText[_i4].sliderRanges[s][0] && props.sliders[s].value <= props.displayText[_i4].sliderRanges[s][1]) {
          var found = viewedCopy.findIndex(function (value) {
            return value.range[0] === props.displayText[_i4].sliderRanges[s][0] && value.range[1] === props.displayText[_i4].sliderRanges[s][1] && value.sliderIndex === s;
          });
          if (found !== -1) {
            viewedCopy.splice(found, 1);
          }
        } else {
          pass = false;
        }
      };
      for (var s = 0; s < props.sliders.length; ++s) {
        _loop3(s);
      }
      if (pass) {
        displayText.push( /*#__PURE__*/_react.default.createElement("p", {
          key: _i4
        }, props.displayText[_i4].text));
        if (props.displayText[_i4].altText) {
          altText.push(props.displayText[_i4].altText);
        }
      } else {
        displayText.push( /*#__PURE__*/_react.default.createElement("p", {
          key: _i4,
          style: {
            display: "none"
          }
        }, props.displayText[_i4].text));
      }
    };
    for (var _i4 = 0; _i4 < props.displayText.length; ++_i4) {
      _loop2(_i4);
    }
    if (viewedCopy.length !== textViewed.length) {
      setTextViewed(viewedCopy);
    }
    return {
      displayText: displayText,
      altText: altText
    };
  };
  var getDisplayText = function getDisplayText() {
    return getDisplayAndAltText().displayText;
  };
  var generateAltText = function generateAltText() {
    var text = '';
    if (props.altTextRanges) {
      var altTextRanges = props.altTextRanges;
      for (var _sliderIndex = 0; _sliderIndex < altTextRanges.length; ++_sliderIndex) {
        if (altTextRanges[_sliderIndex]) {
          for (var _i5 = 0; _i5 < altTextRanges[_sliderIndex].length; ++_i5) {
            if (altTextRanges[_sliderIndex][_i5].minRange <= props.sliders[_sliderIndex].value && props.sliders[_sliderIndex].value < altTextRanges[_sliderIndex][_i5].maxRange) {
              text = text.concat(altTextRanges[_sliderIndex][_i5].altText);
            }
          }
        }
      }
      return text;
    } else {
      var _getDisplayAndAltText = getDisplayAndAltText(),
        altText = _getDisplayAndAltText.altText;
      return altText.join(' ');
    }
  };
  var Sliders = function Sliders() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.sliders.map(function (slider, i) {
      var _slider$handleStyle;
      var marks = generateMarks(props.trackRanges[i]);
      if (props.hiddenMarks) {
        for (var mark = 0; mark < props.hiddenMarks.length; ++mark) {
          var sliderWithExemption = parseInt(Object.keys(props.hiddenMarks[mark])[0]);
          if (sliderWithExemption === i) {
            var exemptionValue = Object.values(props.hiddenMarks[mark])[0];
            marks[exemptionValue] = /*#__PURE__*/_react.default.createElement("span", {
              "aria-hidden": "true",
              className: "sr-only"
            }, marks[exemptionValue]); // hide this mark
          }
        }
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          maxWidth: "95%",
          margin: "0 auto 25px auto"
        },
        key: i
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          textAlign: "center",
          justifyContent: "center"
        }
      }, slider.label), /*#__PURE__*/_react.default.createElement(_TaskSlider.default, {
        new: true,
        min: 0,
        max: 100,
        step: 1,
        value: slider.position,
        onChange: function onChange(value) {
          slider.setPosition(value);
          slider.setValue(sliderValueToGraphValue(value, props.trackRanges[i], props.roundValues));
        },
        marks: marks,
        ariaLabelForHandle: slider.ariaLabelForHandle,
        ariaLabelledByForHandle: slider.ariaLabelledByForHandle,
        handleStyle: (_slider$handleStyle = slider.handleStyle) !== null && _slider$handleStyle !== void 0 ? _slider$handleStyle : {
          width: "20px",
          height: "20px",
          top: "2px"
        }
      }));
    }));
  };
  var multipleGraphs = props.graphs.length !== 1;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: props.style
  }, /*#__PURE__*/_react.default.createElement(_Row.default, null, props.graphs && props.graphs.map(function (v, i) {
    return /*#__PURE__*/_react.default.createElement(_Col.default, null, /*#__PURE__*/_react.default.createElement("div", {
      ref: graphWidthRef,
      style: {
        height: "".concat(width, "px")
      }
    }, v.topText, /*#__PURE__*/_react.default.createElement(_reactChartjs.Scatter, {
      key: i,
      data: v.data,
      options: v.options,
      "aria-label": v.canvasAltText,
      "aria-describedby": "graph-long-alt"
    }), v.bottomText));
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only",
    id: "graph-long-alt",
    "aria-live": "polite"
  }, generateAltText()), !multipleGraphs && /*#__PURE__*/_react.default.createElement(_Col.default, {
    style: props.sliderRowStyle
  }, Sliders())), multipleGraphs && /*#__PURE__*/_react.default.createElement("div", {
    style: (0, _objectSpread2.default)({
      width: "60%",
      marginLeft: "auto",
      marginRight: "auto"
    }, props.sliderRowStyle)
  }, Sliders()), /*#__PURE__*/_react.default.createElement("div", {
    "aria-live": "polite",
    style: {
      marginTop: "2rem"
    }
  }, getDisplayText()));
};
var _default = /*#__PURE__*/_react.default.memo(TaskGraphSlider);
exports.default = _default;